const swup = new Swup({
    containers: ['.uk-navbar-nav', '#swup'],
    linkSelector:
        'a[href^="' +
        window.location.origin +
        '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]):not([target="_blank"]), a[href^="#"]:not([data-no-swup]):not([target="_blank"])',
    animateHistoryBrowsing: true,
    cache: true,
    plugins: [
        new SwupScrollPlugin({
            animateScroll: false
        }),
        new SwupSlideTheme({
            reversed: true
        }),
        new SwupScriptsPlugin({
            head: false,
            body: false,
        }),
        new SwupPreloadPlugin(),
        new SwupBodyClassPlugin()
    ]
});


function funnelInit() {
    window.initAwFunnel();
}
document.addEventListener('swup:contentReplaced', funnelInit);

/*Consent Manager Reload Modal Window - Start*/
function showBoxReload() {
    let boxReloadLink = document.querySelector('.consent_manager-show-box-reload');

    if (boxReloadLink) {
        boxReloadLink.addEventListener('click', () => {
            consent_manager_parameters.forcereload = 1;
            consent_manager_showBox();
        });
    }
}
showBoxReload();
document.addEventListener('swup:contentReplaced', showBoxReload);
/*Consent Manager Reload Modal Window - End*/

/*OSM - Start*/
function init() {
    if(document.querySelector('#map') != null) {
        const map = L.map('map', {
            center: [52.51579, 8.212521],
            zoom: 12,
        });
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);

        const basicBeachIcon = L.icon({
            iconUrl: '/theme/public/assets/frontend/src/img/assetsImg/pin-map.png',
            iconSize: [50, 72],
        });

        const marker = L.marker([52.51579, 8.212521], {icon: basicBeachIcon})
            .bindPopup('<span style="line-height: 1.6"><b>ZERHUSEN Kartonagen GmbH</b><p style="margin: 0;">Industriestraße 9</p><p style="margin: 0;">49401 Damme</p></span>')
            .addTo(map);
    }
}

init();
document.addEventListener('swup:contentReplaced', init);
/*OSM - End*/

/*BTN Formular - Start*/
function replaceFormButtonText() {
    $('.btn').each(function () {
        // get element text
        var html = $(this).html();
        // modify text
        html = html.replace('Formular absenden', "<span>Formular absenden</span>");
        html = html.replace('Send Form', "<span>Send Form</span>");
        // update element text
        $(this).html(html);
    });
}
replaceFormButtonText();
document.addEventListener('swup:contentReplaced', replaceFormButtonText);
/*BTN Formular - End*/


/*Chronik Button Start*/
function swupChronikButton() {
    const button = document.querySelector('.chronik-detail-sidebar-button a');
    if (button) {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            var target = document.querySelector('.chronik-detail-sidebar-button a');

            if (target.classList.contains('active')) {
                target.classList.remove('active');
            } else {
                target.classList.add('active');
            }
        });
    }
}
swupChronikButton();
document.addEventListener('swup:contentReplaced', swupChronikButton);

/*Chronik Button End*/


/*Chronik Tab Scoll to Top Start*/
function swupChronikScroll() {
    const scroll = document.querySelectorAll('.scroll');
    var mobile = (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));

    if (scroll && mobile) {
        for (let scrollTop of scroll)
            scrollTop.addEventListener('click', () => {
                console.log('hello');
                UIkit.scroll(scrollTop).scrollTo('.top')
            });
    }
}
swupChronikScroll();
document.addEventListener('swup:contentReplaced', swupChronikScroll);
/*Chronik Tab Scoll to Top End*/

